var i = Object.defineProperty, O = Object.defineProperties;
var b = Object.getOwnPropertyDescriptors;
var p = Object.getOwnPropertySymbols;
var a = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var l = (r, e, n) => e in r ? i(r, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[e] = n, t = (r, e) => {
  for (var n in e || (e = {}))
    a.call(e, n) && l(r, n, e[n]);
  if (p)
    for (var n of p(e))
      d.call(e, n) && l(r, n, e[n]);
  return r;
}, c = (r, e) => O(r, b(e));
import o from "../../../node_modules/prop-types/index.es.js";
import { BUTTON_COLOR as m } from "../../../constants/color.es.js";
import { COMPONENT_SIZE as f } from "../../../constants/sizes.es.js";
import { COLOR_VARIANT as u } from "../../../constants/colorVariant.es.js";
const s = {
  children: o.node,
  color: o.oneOf(Object.values(m)),
  disabled: o.bool,
  error: o.bool,
  loading: o.bool,
  onClick: o.func,
  rounded: o.bool,
  size: o.oneOf(Object.values(f)),
  variant: o.oneOf(Object.values(u))
}, I = c(t({}, s), {
  block: o.bool,
  endIcon: o.node,
  startIcon: o.node,
  uppercase: o.bool
}), P = c(t({}, s), {
  iconName: o.string
});
export {
  I as buttonPropTypes,
  P as iconButtonPropTypes
};
//# sourceMappingURL=common.es.js.map
